module.exports = __webpack_public_path__ + "img/8b3be68.png";